import React from 'react';
import ReactDOM from 'react-dom/client';
import Carousel from './Carousel';
import PromoBlock from '../Blocks/PromoBlock'

window.React = React 
window.ReactDOM = ReactDOM
window.Carousel = Carousel
window.PromoBlock = PromoBlock
